var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgMoreVertical = props => /*#__PURE__*/React.createElement("svg", _extends({
  className: "svg-safari-fix",
  viewBox: "0 0 24 24",
  fill: "inherit",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 3.98047C11.02 3.98047 10.23 4.77047 10.23 5.75047C10.23 6.73047 11.02 7.52047 12 7.52047C12.98 7.52047 13.77 6.73047 13.77 5.75047C13.77 4.77047 12.98 3.98047 12 3.98047ZM12 10.21C11.02 10.21 10.23 11 10.23 11.98C10.23 12.96 11.02 13.75 12 13.75C12.98 13.75 13.77 12.96 13.77 11.98C13.77 11 12.98 10.21 12 10.21ZM10.23 18.2104C10.23 17.2304 11.02 16.4404 12 16.4404C12.98 16.4404 13.77 17.2304 13.77 18.2104C13.77 19.1904 12.98 19.9804 12 19.9804C11.02 19.9804 10.23 19.1904 10.23 18.2104Z",
  fill: "inherit"
})));
export default SvgMoreVertical;